import axios from "axios";
import config from "../../../settings/config";
import { handleError } from "../../../network/servicErrorHandling";

async function shopInfo(uid) {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/shops/${uid}/info`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function shopsTerms() {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/terms-of-use/sections/seller-shop-info/items`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function edit_shop_properties(uid, params) {
  return Promise.resolve().then((v) =>
    axios
      .put(`${config.baseUrl}v1/shops/${uid}/info`, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function create_media(params) {
  return Promise.resolve().then((v) =>
    axios
      .post(`${config.baseUrl}v1/medias/`, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

export { shopInfo, shopsTerms, edit_shop_properties, create_media };
